import { render } from "./expertCompleteBookingModal.vue?vue&type=template&id=281bbea6&ts=true"
import script from "./expertCompleteBookingModal.vue?vue&type=script&lang=ts"
export * from "./expertCompleteBookingModal.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__